import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import { STEP_STATUS } from '../constants';
import css from './TodosSection.css';

const TodosSection = ({ steps }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    if (!steps || steps.length === 0) return null;

    const completedSteps = steps.filter(s => s.status === STEP_STATUS.COMPLETED).length;
    const totalSteps = steps.length;

    return (
        <div className={css.todosContainer}>
            <div className={css.todosHeader} onClick={() => setIsCollapsed(!isCollapsed)}>
                <div className={css.todosHeaderLeft}>
                    <Icon
                        name={isCollapsed ? 'chevron-right' : 'chevron-down'}
                        size={IconSizes.X_SMALL}
                        className={css.todosCollapseIcon}
                    />
                    <span className={css.todosTitle}>
                        {isCollapsed ? `${completedSteps} of ${totalSteps} tasks completed` : 'Generating Analysis...'}
                    </span>
                </div>
                {!isCollapsed && (
                    <span className={css.todosCount}>
                        {completedSteps}/{totalSteps}
                    </span>
                )}
            </div>

            {!isCollapsed && (
                <div className={css.todosSteps}>
                    {steps.map((step, index) => {
                        const isActive = step.status === STEP_STATUS.RUNNING;
                        const isCompleted = step.status === STEP_STATUS.COMPLETED;
                        const isFailed = step.status === STEP_STATUS.FAILED;
                        const isPending = step.status === STEP_STATUS.PENDING || !step.status;

                        return (
                            <div
                                key={step.step_id || index}
                                className={classNames(css.todosItem, {
                                    [css.todosItemActive]: isActive,
                                    [css.todosItemCompleted]: isCompleted,
                                    [css.todosItemFailed]: isFailed,
                                    [css.todosItemPending]: isPending,
                                })}
                            >
                                <div className={css.todosItemCheckbox}>
                                    <input
                                        type="checkbox"
                                        checked={isCompleted}
                                        disabled
                                        className={css.todosCheckbox}
                                    />
                                    {isActive && (
                                        <Icon name="loader" size={IconSizes.X_SMALL} className={css.todosSpinner} />
                                    )}
                                </div>
                                <div className={css.todosItemContent}>
                                    <div
                                        className={classNames(css.todosItemTitle, {
                                            [css.todosItemTitleCompleted]: isCompleted,
                                        })}
                                    >
                                        {step.title || `Step ${index + 1}`}
                                    </div>
                                </div>
                                {isCompleted && step.duration && (
                                    <div className={css.todosItemDuration}>{step.duration}ms</div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

TodosSection.propTypes = {
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            step_id: PropTypes.string,
            title: PropTypes.string,
            status: PropTypes.oneOf(['pending', 'running', 'completed', 'failed']),
            step_level: PropTypes.number,
            duration: PropTypes.number,
        })
    ).isRequired,
};

export default TodosSection;
